import React from "react";

const TrimmingInput = ({
  type = "text",
  name,
  id,
  placeholder,
  value,
  required,
  autoFocus,
  onChangeOrBlur,
  className,
}) => {
  return (
    <input
      type={type}
      name={name}
      id={id}
      placeholder={placeholder}
      onChange={(e) => onChangeOrBlur(name, e.target.value)}
      value={value}
      required={required}
      autoFocus={autoFocus}
      onBlur={(e) => onChangeOrBlur(name, e.target.value.toString().trim())}
      className={className}
    />
  );
};

export { TrimmingInput };
